import { signInWithPopup, signOut, onAuthStateChanged, User as FirebaseUser } from 'firebase/auth';
import { auth, googleProvider } from '../firebaseConfig';
import api from './api';

export interface User {
  uid: string;
  email: string;
  full_name: string;
  is_admin: boolean;
}

export interface AuthResponse {
  user: User;
  wedding: any;
  is_new: boolean;
}

export const signInWithGoogle = async (): Promise<AuthResponse> => {
  const result = await signInWithPopup(auth, googleProvider);
  const token = await result.user.getIdToken();
  const res = await api.post<AuthResponse>('/auth/google-signin', null, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res.data;
};

export const logOut = async () => {
  await signOut(auth);
};

export const getMe = () => api.get<{ user: User; wedding: any }>('/auth/me');

export const getCurrentFirebaseUser = (): Promise<FirebaseUser | null> => {
  return new Promise((resolve) => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      unsubscribe();
      resolve(user);
    });
  });
};
